import { StyleSheet, View } from 'react-native'
import { BtPlainText } from '@linqpal/components/src/ui'
import React, { FC } from 'react'
import { Icon } from '@ui-kitten/components'

interface IProps {
  text: string
}

export const PaymentPlanHint: FC<IProps> = ({ text }) => {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Icon
        name="alert-circle-outline"
        fill="#001929"
        style={{ width: 16, height: 16 }}
      />
      <BtPlainText style={styles.hint}>{text}</BtPlainText>
    </View>
  )
}

const styles = StyleSheet.create({
  hint: {
    fontWeight: '500',
    fontSize: 12,
    lineHeight: 20,
    marginLeft: 5,
  },
})
